
import Vue from 'vue';
import { TeamUserRoleDef, Team, TeamUserRole, TeamMember } from '@run-diffusion/shared';
import { get$bindFirestoreOptions } from '@/mixins';
import { db } from '@/firebase';
import RoleDefBadge from '@/views/Team/CompanyDashboard/RoleDefBadge.vue';

export default Vue.extend({
	name: 'TeamMemberTeamRoleTableCell',
	props: {
		teamMember: {
			type: Object,
			default: null,
		},
		currTeam: {
			type: Object,
			default: null,
		},
		teamUserRoleDefs: {
			type: Array as () => TeamUserRoleDef[],
			default: () => [],
		},
	},
	data() {
		return {
			loading: false,
			localTeamUserRole: null as TeamUserRole,
		};
	},
	computed: {
        currentRoleDefId(): string {
            if (this.teamMember?.userId) {
                return this.localTeamUserRole?.roleDefId || null;
            }
            return this.teamMember?.teamUserRoleDefId || null;
        },
		roleDef(): TeamUserRoleDef {
			if (!this.currentRoleDefId) return null;
			return this.teamUserRoleDefs.find((def: TeamUserRoleDef) => def.id === this.currentRoleDefId) || null;
		},
	},
	watch: {
		teamMember: {
			immediate: true,
			handler(newVal: TeamMember, oldVal: TeamMember) {
				if (newVal !== oldVal) {
					this.bindTeamUserRole(this.currTeam?.id, newVal);
				}
			},
		},
		currTeam: {
			immediate: true,
			handler(newVal: Team, oldVal: Team) {
				if (newVal !== oldVal) {
					this.bindTeamUserRole(newVal?.id, this.teamMember);
				}
			},
		},
	},
	methods: {
		async bindTeamUserRole(teamId: string, teamMember: TeamMember) {
			if (!teamId || !teamMember?.userId) {
				this.localTeamUserRole = null;
				return;
			}

			this.loading = true;
			try {
				const roleId: string = `${teamId}_${teamMember.userId}`;
				const roleRef = db.collection('teamUserRoles').doc(roleId);
				await this.$bind(
					'localTeamUserRole',
					roleRef,
					get$bindFirestoreOptions({ maxRefDepth: 0 }), // maxRefDepth: 0 because users don't have access to other users' document data
				);
			} catch (error) {
				console.error('Error binding team user role:', error);
			} finally {
				this.loading = false;
			}
		},
	},
	components: {
		RoleDefBadge,
	},
});
